import { Link, useLocation } from "react-router-dom";
import { ArrowRight, MessageSquare } from "lucide-react";

const HIDDEN_PREFIXES = ["/admin", "/dev-hub", "/sales", "/portal", "/auth", "/banned", "/command", "/payment"];

export default function MobileActionBar() {
  const location = useLocation();
  if (HIDDEN_PREFIXES.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <div data-testid="mobile-action-bar" className="md:hidden fixed bottom-0 inset-x-0 z-[60] grid grid-cols-2 border-t border-white/15 bg-[#050505]/95 backdrop-blur-xl">
      <button
        data-testid="mobile-bar-chat"
        onClick={() => window.dispatchEvent(new Event("sp:open-chat"))}
        className="flex items-center justify-center gap-2 py-4 font-sans font-semibold uppercase tracking-[0.15em] text-xs text-nc-blue border-r border-white/10 active:bg-nc-blue/10 transition-colors duration-200"
      >
        <MessageSquare className="w-4 h-4" /> Live Chat
      </button>
      <Link
        to="/contact"
        data-testid="mobile-bar-quote"
        className="flex items-center justify-center gap-2 py-4 font-sans font-semibold uppercase tracking-[0.15em] text-xs text-white bg-nc-orange active:bg-nc-orange/80 transition-colors duration-200"
      >
        Get a Quote <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
